var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile flex align-center"},[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":_vm.defaultImgUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }